module.exports = __webpack_public_path__ + "img/46079a4.jpg";